import React from "react"
import Text from './text'
import Heading  from './heading'
import { ExternalLink, } from './link'

export default function ArtworkMeta({artwork,}) {
    return (
        <div>
            <div style={{display: 'flex', marginTop: '4px', alignItems: 'baseline',}}>
                <Text>{artwork.type}&nbsp;</Text>
                {!!artwork.materials && <Text>({artwork.materials})</Text>}
            </div>

            <Heading type={3}>{artwork.location}</Heading>
            <Text>{artwork.address}</Text>

            {!!artwork.more_info_url && artwork.more_info_url.split("\n").map(url => <div key={url}>
                <ExternalLink href={url}>
                    <Text semibold>More info</Text>
                </ExternalLink>
            </div>)}
        </div>
    )
}